export default {"src":"/_next/static/media/chevron-down.e5a5a334.svg","height":20,"width":20};